import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { ProcessSteps } from '../components/ProcessSteps';
import { CapabilitiesVideo } from '../components/CapabilitiesVideo';
import { Expertise } from '../components/Expertise';
import { Materials } from '../components/Materials';
import { Partnership } from '../components/Partnership';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
import { ChatWidget } from '../components/ChatWidget';
export function Home() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-430">
      <Header data-id="element-431" />
      <main data-id="element-432">
        <Hero data-id="element-433" />
        <Expertise data-id="element-434" />
        <ProcessSteps data-id="element-435" />
        <CapabilitiesVideo data-id="element-436" />
        <Materials data-id="element-437" />
        <Partnership data-id="element-438" />
        <Contact data-id="element-439" />
      </main>
      <Footer data-id="element-440" />
      <ChatWidget data-id="element-441" />
    </div>;
}